import { createContext, useContext, useEffect } from "react";

/**
 * 상단 바 내용 — 화면이 정한다(SCR v0.6 와이어: 학생 홈 '🌿 놀이터 입구 · SE 모드 · 5차시 · 오르막 자동차',
 * 올리기 '⬆ 내 기계 올리기 · SE 모드 · 1/2 → 2/2', 교사 '👩‍🏫 Field · 교사 · 3학년 2반', 놀이터 설정 '⚙ … · PH1 · 룸 없음').
 * 화면이 아무것도 정하지 않으면 AppLayout 기본값(앱 이름)을 쓴다 — 기존 화면·다른 스프린트 화면은 그대로.
 */
export interface TopBarChip {
  label: string;
  testId?: string;
  /** 크게(칠판 뷰 남은 시간 — 와이어 sfs-12 16px) */
  big?: boolean;
}

export interface TopBarSpec {
  icon?: string;
  title?: string;
  /** 밀도 칩(SE 모드 · SU 모드 — 학생만) 뒤에 붙는 칩 */
  chips?: readonly TopBarChip[];
  /** 어른 틀(짙은 상단 바)로 — 세션 없이 여는 관찰자 화면(P3-S5 FS-01-05 · 와이어 top t2) */
  frame?: "adult";
}

export const TopBarCtx = createContext<(spec: TopBarSpec | null) => void>(() => {});

/** 화면이 보이는 동안 상단 바 내용을 정한다. 화면이 사라지면 기본값으로 돌아간다. */
export function useTopBar(spec: TopBarSpec | null) {
  const set = useContext(TopBarCtx);
  const key = JSON.stringify(spec);
  useEffect(() => {
    set(key === "null" ? null : (JSON.parse(key) as TopBarSpec));
  }, [set, key]);
  useEffect(() => () => set(null), [set]);
}
